import PageShell from "@/components/site/PageShell";

export default function Terms() {
  return (
    <PageShell title="Terms of Service" testId="terms-page">
      <div className="mx-auto max-w-3xl px-5 lg:px-8">
        <p className="text-[12px] font-bold uppercase tracking-widest text-terracotta">Legal</p>
        <h1 className="mt-3 text-4xl font-black leading-tight tracking-tight text-charcoal sm:text-5xl">
          Terms of Service
        </h1>
        <p className="mt-3 text-[14px] font-semibold text-charcoal/55">Last updated: June 2026</p>

        <div className="prose-legal mt-10">
          <p>
            These Terms of Service ("Terms") govern your use of the Dishly mobile app and website
            (together, the "Service"). By creating an account or using the Service, you agree to
            these Terms. Dishly is provided by Dishly, Inc. and is operated from the United States.
          </p>

          <h2>1. Accounts</h2>
          <p>
            To use Dishly you must be at least 18 years old and provide accurate account information.
            You are responsible for the activity that happens on your account and for keeping your
            login credentials secure. You may close your account at any time.
          </p>

          <h2>2. What Dishly is</h2>
          <p>
            Dishly is a platform that connects customers with local independent food creators —
            home cooks, food trucks, pop-ups, market vendors, bakers, meal preppers, and caterers.
            We do not prepare or handle food, and we are not the seller of any meal. Every
            transaction is directly between the customer and the creator. Dishly facilitates
            discovery, ordering, communication, and payment.
          </p>

          <h2>3. Acceptable use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service for anything illegal or harmful.</li>
            <li>Harass, threaten, or discriminate against other users.</li>
            <li>Attempt to reverse engineer, disrupt, or interfere with the Service.</li>
            <li>Post false reviews, impersonate other people, or misrepresent your identity or business.</li>
          </ul>

          <h2>4. Creators and food-safety responsibility</h2>
          <p>
            Creators are independent operators. They are solely responsible for their kitchen or
            operating conditions, ingredients, allergens, labeling, packaging, and compliance with
            all applicable local, state, and federal food-safety laws in the United States
            and elsewhere. Creators are responsible for accurately describing their meals and
            disclosing common allergens.
          </p>

          <h2>5. Verification badges</h2>
          <p>
            Dishly reviews applicable permits, licenses and certifications based on the creator's
            business type and location. Verification reflects a document review only; it does not
            guarantee any particular kitchen conditions or outcome. Customers are encouraged to
            review a creator's ratings and information before ordering. Every rating on Dishly
            comes from a verified, completed order.
          </p>

          <h2>6. Orders, cancellations, and refunds</h2>
          <p>
            When you place an order, you enter into a direct transaction with the creator. Order
            prices, delivery fees, and estimated delivery times are shown before you pay. You may
            cancel an order with one tap and receive a full refund before the creator begins cooking.
            Additional cancellation and refund requests are handled on a case-by-case basis; contact
            us at support@dinewithdishly.co and we will work with you and the creator to resolve any issues.
          </p>

          <h2>7. Payments and tips</h2>
          <p>
            Payments are processed securely by Stripe. Dishly does not store full card numbers. Tips
            are optional and go one hundred percent to the creator. Creators receive payouts through
            Stripe and payout summaries by email after every order.
          </p>

          <h2>8. Prohibited items</h2>
          <p>
            The following items may not be listed or sold on Dishly: alcohol, tobacco, cannabis or
            any other controlled substances, drugs, weapons, or any item that is illegal to sell in
            your jurisdiction. Creators who list prohibited items may have their accounts suspended or removed.
          </p>

          <h2>9. Content you provide</h2>
          <p>
            You keep ownership of the photos, meal descriptions, messages, and reviews you post. By
            posting them, you grant Dishly a non-exclusive, worldwide, royalty-free license to display
            them inside the Service so we can operate the marketplace.
          </p>

          <h2>10. Termination</h2>
          <p>
            You may delete your account at any time from Profile → Delete Account or by emailing
            support@dinewithdishly.co. We may suspend or terminate accounts that violate these Terms.
          </p>

          <h2>11. Limitation of liability</h2>
          <p>
            The Service is provided "as is" without warranties of any kind. To the fullest extent
            permitted by law, Dishly is not liable for indirect, incidental, or consequential damages
            arising from your use of the Service, and our total liability for any claim will not
            exceed the amount you paid to Dishly in the six months preceding the claim.
          </p>

          <h2>12. Changes to these Terms</h2>
          <p>
            We may update these Terms from time to time. If we make material changes we will notify
            you inside the app or by email. Continued use of the Service after changes take effect
            means you accept the updated Terms.
          </p>

          <h2>13. Contact</h2>
          <p>
            Questions about these Terms? Email us at{" "}
            <a href="mailto:support@dinewithdishly.co">support@dinewithdishly.co</a>.
          </p>
        </div>
      </div>
    </PageShell>
  );
}
